import { ROUTES } from '../constants/routes';

/** Legacy Clerk sign-in sub-paths when SignIn used `path="/"` at the app root. */
const CLERK_SIGN_IN_SUBPATHS = [
  '/verify-email-address',
  '/factor-one',
  '/factor-two',
  '/sso-callback',
  '/continue',
  '/reset-password',
];

/**
 * Paths where the user may be mid Clerk sign-in/sign-up (including email verification).
 * Route guards and 401 handlers must not redirect away from these URLs.
 */
export function isPublicAuthPath(pathname) {
  if (!pathname) return false;

  const path = pathname.split('?')[0].split('#')[0];

  if (path === '/' || path === ROUTES.LOGIN || path === ROUTES.SIGNUP) {
    return true;
  }

  if (path.startsWith(`${ROUTES.LOGIN}/`) || path.startsWith(`${ROUTES.SIGNUP}/`)) {
    return true;
  }

  return CLERK_SIGN_IN_SUBPATHS.some(
    (segment) => path === segment || path.startsWith(`${segment}/`)
  );
}
